import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import HomePage from "../pages/home/page";
import HowItWorks from "../pages/how-it-works/page";
import Pricing from "../pages/pricing/page";
import Payment from "../pages/payment/page";
import PaymentComplete from "../pages/payment-complete/page";
import RegistrationComplete from "../pages/registration-confirmation/page";
import PaymentFailed from "../pages/payment-failed/page";
import PaymentFree from "../pages/payment-free/page";
import About from "../pages/about/page";
import Contact from "../pages/contact/page";
import Accountants from "../pages/affiliates/accountants/page";
import Consultants from "../pages/affiliates/consultants/page";
import Partners from "../pages/affiliates/partners/page";
import AdminDashboard from '../pages/admin/page';
import TestEmailPage from '../pages/test-email/page';
import PrivacyPolicy from '../pages/privacy-policy/page';
import TermsOfService from '../pages/terms-of-service/page';
import EmailMarketing from '../pages/email-marketing/page';
import EmailMarketingRaw from '../pages/email-marketing-raw/page';
import InvoiceBanner from '../pages/invoice-banner/page';
import LoginPage from '../pages/login/page';
import ExtensionInstallChrome from '../pages/extension-install-chrome/page';
import ExtensionInstallChromeQBOVerifier from '../pages/extension-install-chrome-QBOVerifier/page';
import ExtensionInstallChromeXEROVerifier from '../pages/extension-install-chrome-XEROVerifier/page';
import InvoiceVerification from '../pages/invoice-verification/page';
import OverridePage from '../pages/override/page';
import LinkedInLanding from '../pages/linkedin-landing/page';
import CustomInvoiceDesign from '../pages/custom-invoice-design/page';
import CustomInvoiceDesignExperiment from '../pages/custom-invoice-design-experiment/page';

const routes: RouteObject[] = [
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/how-it-works",
    element: <HowItWorks />,
  },
  {
    path: "/pricing",
    element: <Pricing />,
  },
  {
    path: "/payment",
    element: <Payment />,
  },
  {
    path: "/payment-complete",
    element: <PaymentComplete />,
  },
  {
    path: "/registration-complete",
    element: <RegistrationComplete />,
  },
  {
    path: "/payment-failed",
    element: <PaymentFailed />,
  },
  {
    path: "/payment-free",
    element: <PaymentFree />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/affiliates/accountants",
    element: <Accountants />,
  },
  {
    path: "/affiliates/consultants",
    element: <Consultants />,
  },
  {
    path: "/affiliates/partners",
    element: <Partners />,
  },
  {
    path: "/admin",
    element: <AdminDashboard />,
  },
  {
    path: "/test-email",
    element: <TestEmailPage />,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicy />,
  },
  {
    path: "/terms-of-service",
    element: <TermsOfService />,
  },
  {
    path: "/email-marketing",
    element: <EmailMarketing />,
  },
  {
    path: "/email-marketing-raw",
    element: <EmailMarketingRaw />,
  },
  {
    path: "/invoice-banner",
    element: <InvoiceBanner />,
  },
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/extension-install-chrome",
    element: <ExtensionInstallChrome />,
  },
  {
    path: "/extension-install-chrome-XeroVerifier",
    element: <ExtensionInstallChromeXEROVerifier />,
  },
  {
    path: "/extension-install-chrome-XEROVerifier",
    element: <ExtensionInstallChromeXEROVerifier />,
  },
  {
    path: "/invoice-verification",
    element: <InvoiceVerification />,
  },
  {
    path: "/override",
    element: <OverridePage />,
  },
  {
    path: "/from-linkedin",
    element: <LinkedInLanding />,
  },
  {
    path: "/custom-invoice-design-original",
    element: <CustomInvoiceDesign />,
  },
  {
    path: "/custom-invoice-design",
    element: <CustomInvoiceDesignExperiment />,
  },
  {
    path: "/custom-invoice-design-experiment",
    element: <CustomInvoiceDesignExperiment />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;

